export default __webpack_public_path__ + "static/media/bronzeAward.b14b96d9.svg";